
import React from 'react';
import { RCTag } from '@reverbdotcom/cadence/components';
import I18n from 'i18n-js';

type Variant = 'incomplete' | 'pending' | 'verified' ;
export interface Props {
  variant: Variant;
}

export function TinVerificationStatus({ variant }: Props) {
  const message = () => {
    switch (variant) {
      case 'pending':
        return I18n.t('discovery.taxProfile.tinVerification.pending');
      case 'verified':
        return I18n.t('discovery.taxProfile.tinVerification.complete');
      default:
        return I18n.t('discovery.taxProfile.tinVerification.incomplete');
    }
  };

  return (
    <RCTag
      variant={variant === 'verified' ? 'success' : 'default'}
    >
      <span className={variant === 'pending' ? 'tin-verification__state--pending' : ''}>{message()}</span>
    </RCTag>
  );
}

export default TinVerificationStatus;
